import icon_lock from '../../../assets/images/icon_lock_group.svg'
import { generateAvatar } from "../../../utils";
import { ContextState } from '../../../layout';
import { useContext} from "react";
import dayjs from 'dayjs';
import Cookies from 'js-cookie';

const UserInfo = ({ userdata, course, group, skill }) => {
    const { contextReducer } = useContext(ContextState);
    let fullName = `${userdata?.userdetails?.first_name} ${userdata?.userdetails?.last_name}`;
    let fullName_cert = `${userdata?.first_name} ${userdata?.last_name}`;
    const role = Cookies.get('cms_role');

    const tableHeaders = [
        { key: 'name', title: 'certificate course' },
        { key: 'certificate_status', title: 'certificate status' },
        { key: 'issued_date', title: 'certificate issued' },
      ];

    function DynamicTable({ tableData, tableHeaders }) {
        return (
          <div>
            <table className='cert_user'>
              <thead className='cert_user_header'>
                <tr>
                  {tableHeaders.map((header) => (
                    <th className={header.key === 'course_status' ? 'user_details_list' :"" } key={header.key}>{header.title}</th>
                  ))}
                </tr>
              </thead>
              <tbody className='cert_user_body'>
                {tableData?.map((row, index) => {
                  return <tr key={index}>
                    
                    {tableHeaders?.map((header) => {
                        let data = header.key === 'issued_date' ?  row[header.key] ?  dayjs(row[header.key]).format("MM/DD/YYYY") : " - " : row[header.key]
                        return <td className={header.key === 'certificate_status' ? 'user_details_list' :"" } key={header.key} >{data}</td>
                })}
                  </tr>
                })}
              </tbody>
            </table>
          </div>
        );
      }

      
    return (
        <>
            <div className="modal_header">
                <div className="user_info">
                    <div className="user_info_img">{contextReducer.cms_type === 'certificates' ? 
                        <img src={userdata?.avatar ? userdata?.avatar : generateAvatar(fullName_cert)} alt="User image" height="42" width="42" className="radius_rounded img_object_center" />:
                        <img src={userdata?.userdetails?.avatar ? userdata?.userdetails?.avatar : generateAvatar(fullName)} alt="User image" height="42" width="42" className="radius_rounded img_object_center" />
                    
                    }
                    </div>
                    <div className="user_info_name_work">
                        <p className="user_name" style={{ fontFamily: 'national_semibold' }}>{ contextReducer.cms_type === 'certificates' ? userdata?.first_name :userdata?.userdetails?.first_name}</p>
                        <p className="user_work">{contextReducer.cms_type === 'certificates' ? userdata?.last_name: userdata?.userdetails?.last_name}</p>
                    </div>
                </div>
            </div>
            
            <div className="modal_body">
            {contextReducer.cms_type !== 'certificates' &&
             <div className="user user_course_groups_skills_list mt_5">
             <div className="user_details_list user_courses">
                 <h2>{contextReducer.cms_type === 'certificates' ? "certificate course " : "courses"}</h2>
                 
                 <ul className="list_unstyled fullWidth user_details_li">
                      {course?.map(cor => 
                         <li>
                             <div className="user_courses_details">
                                 <div className="user_courses_details_name">{cor.name}</div>
                                 <div className="user_courses_details_status"><span className={ role === "Contributor" ? `btn_status ${cor.course_status === 'Completed' && 'success' } contributor_status` :`btn_status ${cor.course_status === 'Completed' && 'success' } contributor_status`}>{cor.course_status}</span></div>
                             </div>
                         </li>
                     )} 
                 </ul>
             </div>
             <div className="user_details_list user_groups">
             <h2>{contextReducer.cms_type === 'certificates' ? "certificate status" : "groups"}</h2>
                 {/* <h2>groups</h2> */}
                 <ul className="list_unstyled fullWidth user_details_li">
                     {group?.map(gro =>
                         <li>
                             <div className="user_groups_details">
                                 <div className="user_groups_details_image">
                                     <img src={gro.cover_image} alt="Group icon" height="20" width="20" className="img_object_center radius_5" />
                                 </div>
                                 <div className="user_groups_details_name_owner">
                                     <p>{gro.name} {gro.type === 'closed' && <img src={icon_lock} alt="Lock icon" height="12" />}</p>
                                     <p className="user_owner">{gro.owner ? 'Owner' : ''}</p>
                                 </div>
                             </div>
                         </li>
                     )}
                 </ul>
             </div>
             <div className="user_details_list user_skills">
             <h2>{contextReducer.cms_type === 'certificates' ? "certificate issued" : "skills"}</h2>
                 {/* <h2>skills</h2> */}
                 <ul className="list_unstyled fullWidth user_details_li">
                     {skill?.map(ski =>
                         <li>
                             <div className="user_skills_details">
                                 <div className="user_skills_details_name">{ski.name}</div>
                                 <div className="user_skills_details_status"><span className={role === "Contributor" ? `btn_status ${ski.status === 'Earned' && 'success'} contributor_status` :  `btn_status ${ski.status === 'Earned' && 'success'}`} >{ski.status}</span></div>
                             </div>
                         </li>
                     )}
                 </ul>
             </div>
         </div>
            }
               


               { contextReducer.cms_type === 'certificates' && <DynamicTable tableData={course} tableHeaders={tableHeaders} />}
            </div>
        </>
    )
};

export default UserInfo